const makeSelector = (description, attrName, childSelector) => {
  return {
    selector: `[${attrName}]${childSelector ? ` ${childSelector.selector}` : ""}`,
    description
  };
};
export {
  makeSelector
};
